/** Applies PATCH indicator response onto flattened dimensional V2 rows (in-place map). */
export default function patchDimensionalIndicatorsFromUpdate(
  rows: any[] | null | undefined,
  indicatorId: number | string,
  patchResponse: Record<string, any>,
): any[] {
  if (!rows?.length) return rows ?? [];

  const patchId = Number(indicatorId);
  if (Number.isNaN(patchId)) return rows;

  const format = patchResponse.data_format ?? patchResponse.format;
  const indicatorType = patchResponse.indicator_type ?? patchResponse.type;
  const formatProperties = patchResponse.data_format_properties ?? patchResponse.format_properties;

  return rows.map((row) => {
    const isParent = row?.chevronType !== 'child' && Number(row?.id) === patchId;
    if (!isParent) return row;

    return {
      ...row,
      ...(patchResponse.name != null ? { name: patchResponse.name } : {}),
      ...(format != null ? { type: format, format } : {}),
      ...(patchResponse.data_type != null ? { data_type: patchResponse.data_type } : {}),
      ...(indicatorType != null ? { indicator_type: indicatorType } : {}),
      ...(formatProperties != null ? { format_properties: formatProperties } : {}),
      ...(patchResponse.output_format != null
        ? { output_format: patchResponse.output_format }
        : {}),
      ...(patchResponse.chart_type != null ? { chart_type: patchResponse.chart_type } : {}),
      ...(patchResponse.favourite != null ? { is_favourite: patchResponse.favourite } : {}),
      ...(patchResponse.warning != null ? { warning: patchResponse.warning } : {}),
      ...(patchResponse.help != null ? { help: patchResponse.help } : {}),
      ...(patchResponse.formula != null ? { formula: patchResponse.formula } : {}),
    };
  });
}
